import React from "react";
import { useResponsive } from "../../../../hooks/useResponsive";

function MilestoneProgressBar({
  allocatedHours,
  hoursSpent,
  exceedHours,
  remainingHours,
}) {
  const isMobile = useResponsive("down", "md");

  const dropzoneStyle = (width) => ({
    width: `${width}%`,
  });

  const green =
    allocatedHours && hoursSpent
      ? Math.round(
          ((hoursSpent - exceedHours) / (allocatedHours + exceedHours)) * 100
        ) == 0
        ? 1
        : Math.round(
            ((hoursSpent - exceedHours) / (allocatedHours + exceedHours)) * 100
          )
      : 0;

  const red =
    allocatedHours && exceedHours
      ? Math.round((exceedHours / (allocatedHours + exceedHours)) * 100) == 0
        ? 1
        : Math.round((exceedHours / (allocatedHours + exceedHours)) * 100)
      : 0;

  return (
    <div>
      <div className="d-flex justify-content-space-between">
        <p className="complete-percent">
          {(allocatedHours - remainingHours)?.toFixed(2)}/{allocatedHours} hrs
        </p>
        <p className="complete-percent">{exceedHours} hrs</p>
      </div>
      <div className="milestone-progress-bar-main-container">
        <div
          className="milestone-progress-bar-section-1"
          style={{
            ...dropzoneStyle(green),
          }}
        ></div>
        <div
          className="milestone-progress-bar-section-2"
          style={{
            ...dropzoneStyle(red),
          }}
        ></div>
      </div>
      <div className="d-flex justify-content-end">
        <p className="complete-percent">
          {allocatedHours
            ? Math.round(
                ((allocatedHours - remainingHours) / allocatedHours) * 100
              )
            : "0"}
          % Completed
        </p>
      </div>
    </div>
  );
}

export default MilestoneProgressBar;
